import { render, staticRenderFns } from "./ServerFilterListTable.vue?vue&type=template&id=4f0f0498&"
import script from "./ServerFilterListTable.vue?vue&type=script&lang=js&"
export * from "./ServerFilterListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QAvatar} from 'quasar'
component.options.components = Object.assign({QChip,QAvatar}, component.options.components || {})
